// extracted by mini-css-extract-plugin
module.exports = {"modal":"OutOfGroupModal_modal__2dCGf","header":"OutOfGroupModal_header__1wI3y","headerText":"OutOfGroupModal_headerText__Z3KKt","footer":"OutOfGroupModal_footer__21Q0f"};